// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function decodeBase64AndParseJson(encodedString: string): any | null {
    if (!encodedString) {
        return null;
    }
    try {
        const decodedString = atob(encodedString);
        return JSON.parse(decodedString);
    } catch (error) {
        console.error('Error decoding or parsing JSON from base64 string:', error);
        return null;
    }
}

export function encodeJsonToBase64(data: any): string | null {
    if (!data) {
        return null;
    }
    try {
        const jsonString = JSON.stringify(data);
        return btoa(jsonString);
    } catch (error) {
        console.error('Error encoding JSON to base64 string:', error);
        return null;
    }
}

export function deepClone<T>(obj: T): T {
    if (obj === null || obj === undefined) {
        return obj;
    }
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        console.error('Error deep cloning object:', error);
        return obj;
    }
}
